import {
  Default_getInstance2btmaxiazehss as Default_getInstance,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  isNumberiramasdbon0i as isNumber,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  VOID3gxj6tk5isa35 as VOID,
  protoOf180f3jzyo7rfj as protoOf,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  to2cs3ny02qtbcb as to,
  printStackTrace18lnx7a39cni as printStackTrace,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
  lazy2hsh8ze7j6ikd as lazy,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
} from './kotlin-kotlin-stdlib.mjs';
import {
  get_Deflate2a0lyute7oxjd as get_Deflate,
  uncompress3ofkd276wd0zn as uncompress,
} from './korlibs-compression-root-korlibs-compression.mjs';
import { getS32LE1pxm9wohin3g8 as getS32LE } from './korlibs-memory-root-korlibs-memory.mjs';
import { jsObjectr1r5ao37ef4f as jsObject } from './korlibs-platform-root-korlibs-platform.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class IWASMLib {}
function readBytes(pos, size) {
  // Inline function 'kotlin.TODO' call
  throw NotImplementedError.le();
}
function writeBytes(pos, data) {
  // Inline function 'kotlin.TODO' call
  throw NotImplementedError.le();
}
function invokeFunc(name, params) {
  // Inline function 'kotlin.TODO' call
  throw NotImplementedError.le();
}
function invokeFuncInt(name, params) {
  var tmp = this.tbj(name, params.slice());
  var tmp0_safe_receiver = isNumber(tmp) ? tmp : null;
  var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : numberToInt(tmp0_safe_receiver);
  return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
}
function invokeFuncUnit(name, params) {
  this.tbj(name, params.slice());
}
function readInts(pos, size) {
  var bytes = this.rbj(pos, imul(size, 4));
  var tmp = 0;
  var tmp_0 = new Int32Array(size);
  while (tmp < size) {
    var tmp_1 = tmp;
    tmp_0[tmp_1] = getS32LE(bytes, imul(tmp_1, 4));
    tmp = tmp + 1 | 0;
  }
  return tmp_0;
}
function allocBytes(size) {
  return this.ubj('malloc', [size]);
}
function allocBytes_0(bytes) {
  // Inline function 'kotlin.also' call
  var this_0 = this.xbj(bytes.length);
  this.sbj(this_0, bytes);
  return this_0;
}
function allocInts(size) {
  return this.xbj(imul(size, 4));
}
function freeBytes(ptrs) {
  var inductionVariable = 0;
  var last = ptrs.length;
  while (inductionVariable < last) {
    var ptr = ptrs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    this.tbj('free', [ptr]);
  }
}
class WASMLib {
  constructor(content) {
    this.qbj_1 = new JSWASMLib(content);
  }
  rbj(pos, size) {
    return this.qbj_1.rbj(pos, size);
  }
  sbj(pos, data) {
    this.qbj_1.sbj(pos, data);
  }
  tbj(name, params) {
    return this.qbj_1.tbj(name, params);
  }
  ubj(name, params) {
    return this.qbj_1.ubj(name, params);
  }
  vbj(name, params) {
    this.qbj_1.vbj(name, params);
  }
  wbj(pos, size) {
    return this.qbj_1.wbj(pos, size);
  }
  xbj(size) {
    return this.qbj_1.xbj(size);
  }
  ybj(bytes) {
    return this.qbj_1.ybj(bytes);
  }
  zbj(size) {
    return this.qbj_1.zbj(size);
  }
  abk(ptrs) {
    this.qbj_1.abk(ptrs);
  }
  f7() {
    this.qbj_1.f7();
  }
}
class Base64DeflateWASMLib extends WASMLib {
  constructor(content) {
    super(uncompress(Default_getInstance().oq(content), get_Deflate()));
  }
}
class BaseWASMLib {
  constructor(content) {
    this.bbk_1 = content;
    this.cbk_1 = null;
  }
  s2f() {
    return this.bbk_1;
  }
  f7() {
  }
}
class JSWASMLib extends BaseWASMLib {
  constructor(content) {
    super(content);
    this.fbk_1 = null;
    var tmp = this;
    tmp.gbk_1 = lazy(JSWASMLib$mem$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.hbk_1 = lazy(JSWASMLib$u8$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.ibk_1 = lazy(JSWASMLib$dataView$delegate$lambda(this));
  }
  rbj(pos, size) {
    var out = new Int8Array(size);
    var u8 = _get_u8__ndcayw(this);
    var inductionVariable = 0;
    var last = out.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        out[n] = u8[pos + n | 0];
      }
       while (inductionVariable <= last);
    return out;
  }
  sbj(pos, data) {
    var inductionVariable = 0;
    var last = data.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        _get_u8__ndcayw(this)[pos + n | 0] = data[n];
      }
       while (inductionVariable <= last);
  }
  tbj(name, params) {
    var tmp0_elvis_lhs = _get_wasmExports__dbcjyi(this)[name];
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = "Can't find export '" + name + "'";
      throw IllegalStateException.o(toString(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var export_0 = tmp;
    return export_0.apply(_get_wasmExports__dbcjyi(this), params);
  }
  f7() {
    super.f7();
  }
}
//endregion
function _get_wasmExports__dbcjyi($this) {
  if ($this.fbk_1 == null) {
    var tmp = $this;
    var tmp_0;
    try {
      var module_0 = new WebAssembly.Module(ensureNotNull($this.s2f()));
      var dummyFunc = JSWASMLib$_get_wasmExports_$lambda_zfsn0h;
      var imports = jsObject([to('env', jsObject([to('abort', dummyFunc), to('emscripten_notify_memory_growth', dummyFunc)])), to('wasi_snapshot_preview1', jsObject([to('proc_exit', dummyFunc), to('fd_close', dummyFunc), to('fd_write', dummyFunc), to('fd_seek', dummyFunc)]))]);
      tmp_0 = (new WebAssembly.Instance(module_0, imports)).exports;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.also' call
    tmp.fbk_1 = tmp_0;
  }
  return $this.fbk_1;
}
function _get_mem__e6cqxo($this) {
  var tmp0 = $this.gbk_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('mem', 1, tmp, JSWASMLib$_get_mem_$ref_5hck8x(), null);
  return tmp0.k3();
}
function _get_u8__ndcayw($this) {
  var tmp0 = $this.hbk_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('u8', 1, tmp, JSWASMLib$_get_u8_$ref_che3b1(), null);
  return tmp0.k3();
}
function JSWASMLib$_get_wasmExports_$lambda_zfsn0h() {
  console.log('proc_exit', arguments);
  return Unit_instance;
}
function JSWASMLib$mem$delegate$lambda(this$0) {
  return () => _get_wasmExports__dbcjyi(this$0).memory.buffer;
}
function JSWASMLib$_get_mem_$ref_5hck8x() {
  return constructCallableReference((p0) => _get_mem__e6cqxo(p0), 1, 0, 84);
}
function JSWASMLib$u8$delegate$lambda(this$0) {
  return () => new Uint8Array(_get_mem__e6cqxo(this$0));
}
function JSWASMLib$_get_u8_$ref_che3b1() {
  return constructCallableReference((p0) => _get_u8__ndcayw(p0), 1, 0, 85);
}
function JSWASMLib$dataView$delegate$lambda(this$0) {
  return () => new DataView(_get_mem__e6cqxo(this$0));
}
//region block: post-declaration
initMetadataForInterface(IWASMLib, 'IWASMLib', VOID, VOID, [AutoCloseable]);
initMetadataForClass(WASMLib, 'WASMLib', VOID, VOID, [IWASMLib]);
initMetadataForClass(Base64DeflateWASMLib, 'Base64DeflateWASMLib');
protoOf(BaseWASMLib).rbj = readBytes;
protoOf(BaseWASMLib).sbj = writeBytes;
protoOf(BaseWASMLib).tbj = invokeFunc;
protoOf(BaseWASMLib).ubj = invokeFuncInt;
protoOf(BaseWASMLib).vbj = invokeFuncUnit;
protoOf(BaseWASMLib).wbj = readInts;
protoOf(BaseWASMLib).xbj = allocBytes;
protoOf(BaseWASMLib).ybj = allocBytes_0;
protoOf(BaseWASMLib).zbj = allocInts;
protoOf(BaseWASMLib).abk = freeBytes;
initMetadataForClass(BaseWASMLib, 'BaseWASMLib', VOID, VOID, [IWASMLib]);
initMetadataForClass(JSWASMLib, 'JSWASMLib', VOID, VOID, [IWASMLib]);
//endregion
//region block: exports
export {
  Base64DeflateWASMLib as Base64DeflateWASMLib1nkue0zm1qc0o,
};
//endregion
